export default [
    {
        path: '/petrifaction',
        name: 'petrifaction',
        component: () =>
            import ('@/views/Concise/petrifaction/index.vue'),
    },
    {
        path: '/petrhome',
        name: 'petrhome',
        component: () =>
            import ('@/views/Concise/home.vue'),
    },
    //产业现状
    {
        path: '/industry',
        name: 'industry',
        component: () =>
            import ('@/views/Concise/petrifaction/industry.vue'),
    },
    //投资方向
    {
        path: '/investment',
        name: 'investment',
        component: () =>
            import ('@/views/Concise/petrifaction/investment.vue'),
    },
    //项目凝练
    {
        path: '/project',
        name: 'project',
        component: () =>
            import ('@/views/Concise/petrifaction/project.vue'),
    },
     //项目凝练详情页
     {
        path: '/details',
        name: 'details',
        component: () =>
            import ('@/views/Concise/petrifaction/project-det.vue'),
    },
]